export default __webpack_public_path__ + "static/media/logo.6614d7be.svg";